import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import api from "../../utils/api";

function ViewEmployee() {
  const { empid } = useParams();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [employeeData, setEmployeeData] = useState({});

  const fetchEmployee = async () => {
    try {
      const response = await api.get(`/employee/${empid}`);
      setEmployeeData(response.data);
    } catch (error) {
      console.error("Failed to fetch employee details", error);
    }
  };

  useEffect(() => {
    fetchEmployee();
  }, []);

  const infoRow = (label, value) => (
    <div className="flex flex-col p-4 bg-gray-50 rounded-lg shadow-sm">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-base font-medium text-gray-800">
        {value || "-"}
      </span>
    </div>
  );

  return (
    <div className="w-full h-full px-4 sm:px-6 pb-20">
      <div className="flex items-center gap-4 py-4 sm:py-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-3 py-1.5 rounded-full border hover:bg-gray-100 transition"
        >
          <MdArrowBack className="text-lg" /> Back
        </button>
        <h2 className="text-xl sm:text-2xl font-bold text-slate-800">
          View Employee
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Column 1 */}
        <div className="space-y-4">
          {infoRow("Full Name", employeeData.name)}
          {infoRow("Employee ID", employeeData.employeeId)}
          {infoRow("Base Location", employeeData.location)}
          {infoRow("Designation", employeeData.designation)}
          {infoRow("Contact Number", employeeData.contactNumber)}
          {infoRow("Reporting Manager", employeeData.reportingManager)}
          {infoRow("Department", employeeData.department)}
        </div>

        {/* Column 2 */}
        <div className="space-y-4">
          {infoRow("Email ID", employeeData.email)}
          {infoRow("Bank Name", employeeData.bankName)}
          {infoRow("Account Number", employeeData.accountNumber)}
          {infoRow("IFSC Code", employeeData.ifsccode)}
          {infoRow("Emergency Contact", employeeData.emergencyContactNumber)}
          {infoRow("Cost Center", employeeData.costCenter)}
          {infoRow("Work Mode", employeeData.office)}
        </div>

        {/* Column 3 */}
        <div className="space-y-4">
          {infoRow("PAN Number", employeeData.panno)}
          {infoRow("Aadhar Number", employeeData.aadarNo)}
          {infoRow("UAN Number", employeeData.uanno)}
          {infoRow("ESI Number", employeeData.esino)}
          {infoRow("Date of Joining", employeeData.doj)}
          {infoRow("Role", employeeData.role)}
        </div>
      </div>
    </div>
  );
}

export default ViewEmployee;
